export default {
  videoURL: process.env.REACT_APP_VIDEO_URL || 'http://localhost:3001',
}
